module.exports = __webpack_public_path__ + "static/media/temperature-control-in-place_filter.99132822.svg";